import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { Modal } from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
    selector: 'app-modal-template-small',
    templateUrl: './modal-template-small.component.html',
    styleUrls: ['./modal-template-small.component.scss'],
    animations: [showHide],
    standalone: true
})
export class ModalTemplateSmallComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
